export const PARENT = '__parent';
export const USER_APP_IFRAME_ID = 'user-app-iframe';
